import {
  BRIEFINGS_FETCHING,
  BRIEFINGS_FETCHING_FAILURE,
  BRIEFINGS_FETCHING_SUCCESS,
  BRIEFINGS_LABELS_FAILURE,
  BRIEFINGS_LABELS_FETCHING,
  BRIEFINGS_LABELS_SUCCESS,
  BRIEFINGS_MORE_FETCHING,
  BRIEFINGS_MORE_FETCHING_FAILURE,
  BRIEFINGS_MORE_FETCHING_SUCCESS,
  BRIEFINGS_RESET,
  RESET_STORED_DATA
} from '../actions/actionTypes';
import { mergeSections } from './myNews';

const initialState = {
  labels: [],
  tabs: {},
  isFetchingLabels: false,
  error: null
};

const fetchingLabels = (state) => ({
  ...state,
  isFetchingLabels: true
});

const fetchingLabelsSuccess = (state, { payload: { items } }) => ({
  ...state,
  isFetchingLabels: false,
  labels: [...(items || [])],
});

const fetchingLabelsFailure = (state) => ({
  ...state,
  isFetchingLabels: false,
  error: true
});

const fetchingData = (state, { payload: { briefingId } }) => ({
  ...state,
  tabs: {
    ...state.tabs,
    [briefingId]: {
      ...state.tabs[briefingId],
      isFetching: true
    }
  }
});

const fetchingSuccess = (
  state,
  { payload: { sections, links, briefingId } }
) => ({
  ...state,
  tabs: {
    ...state.tabs,
    [briefingId]: {
      isFetching: false,
      firstRequest: false,
      sections: [...sections],
      links
    }
  }
});

const fetchingFailure = (state, { error: { error, briefingId } }) => ({
  ...state,
  tabs: {
    ...state.tabs,
    [briefingId]: {
      isFetching: false,
      error
    }
  }
});

const fetchingMoreData = (state, { payload: { briefingId } }) => ({
  ...state,
  tabs: {
    ...state.tabs,
    [briefingId]: {
      ...state.tabs[briefingId],
      isFetching: true
    }
  }
});

const fetchingMoreSuccess = (
  state,
  { payload: { sections, links, briefingId } }
) => {
  const merged = mergeSections(
    state.tabs[briefingId].sections,
    sections,
    links
  );
  if (merged) {
    return {
      ...state,
      tabs: {
        ...state.tabs,
        [briefingId]: {
          ...state.tabs[briefingId],
          ...merged,
          sections: merged.sections.map((section) => ({
            ...section,
            disabled: true
          }))
        }
      }
    };
  }

  return {
    ...state,
    tabs: {
      ...state.tabs,
      [briefingId]: {
        ...state.tabs[briefingId],
        sections: [...state.tabs[briefingId].sections, ...sections].map(
          (section) => ({
            ...section,
            disabled: true
          })
        ),
        isFetching: false,
        links
      }
    }
  };
};

const fetchingMoreFailure = (state, { payload: { briefingId } }) => ({
  ...state,
  tabs: {
    ...state.tabs,
    [briefingId]: {
      isFetching: false,
      error: true
    }
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case BRIEFINGS_LABELS_FETCHING:
      return fetchingLabels(state, action);

    case BRIEFINGS_LABELS_SUCCESS:
      return fetchingLabelsSuccess(state, action);

    case BRIEFINGS_LABELS_FAILURE:
      return fetchingLabelsFailure(state, action);

    case BRIEFINGS_FETCHING:
      return fetchingData(state, action);

    case BRIEFINGS_FETCHING_SUCCESS:
      return fetchingSuccess(state, action);

    case BRIEFINGS_FETCHING_FAILURE:
      return fetchingFailure(state, action);

    case BRIEFINGS_MORE_FETCHING:
      return fetchingMoreData(state, action);

    case BRIEFINGS_MORE_FETCHING_SUCCESS:
      return fetchingMoreSuccess(state, action);

    case BRIEFINGS_MORE_FETCHING_FAILURE:
      return fetchingMoreFailure(state, action);

    case RESET_STORED_DATA:
    case BRIEFINGS_RESET:
      return initialState;

    default:
      return state;
  }
};
